import * as Yup from 'yup';

export const SignUpMoreInfoSchema = Yup.object().shape({
  industryType: Yup.string()
    .min(1)
    .required('Please provide your industry type'),
  fleetSize: Yup.string()
    .min(1)
    .required('Please provide your fleet size'),
  typicalRoute: Yup.array()
    .of(Yup.string().required())
    .min(1, 'Please select your routes')
    .required('Please select your routes'),

  deliveryVehicleTypes: Yup.array()
    .of(Yup.string().required())
    .min(1, 'Please select at least one vehicle')
    .required('Please select your vehicles'),
});

export type SignUpMoreInfoDataType = Yup.InferType<typeof SignUpMoreInfoSchema>;

type InitialValues = {
  industryType: string;
  fleetSize: string;
  typicalRoute: string[];
  deliveryVehicleTypes: string[];
};

export const signUpMoreInfoInitialValues: InitialValues = {
  industryType: '',
  fleetSize: '',
  typicalRoute: [],
  deliveryVehicleTypes: [],
};


export interface MoreInfoSliderInterface {
  fleetSize: string;
  typicalRoute: string[];
  deliveryVehicleTypes: string[];
};
